<template>
    <div class="onBOx">
        
        <div class="feature">
            <slot name="leftBten"></slot>
            <span v-if="config.allBtn" class="r-bgth" @click="showAll()">
                <img src="@/assets/img/Frame.png">批量操作
            </span>
            <span v-if="filterForm && filterForm.length>0" class="feature-item filter" @click="drawerFn()">
                <img src="@/assets/img/icon_sx.svg">筛选
            </span>
		</div>
        <div class="all_btns" v-if="config.showAllBtn">          
            <div class="all_btns_1">
                已选{{selectedD}}个
            </div>
            <div class="all_btns_2">
                <span @click="el.clickFn" v-for="(el,index) in config.allBtn" :key="index">
                    {{el.label}}
                </span>
            </div>
        </div>
        <div class="tabl_op">
            <comTable @selectedDatafn="selectedDatafn" :config="config" ref="table"></comTable>
        </div>
        <el-drawer
          :title="'筛选'"
          class="drawer-box"
          :visible.sync="drawer"
          :before-close="handleClose">
            <el-form :label-position="'top'" :model="form" ref="form">
                <el-form-item v-for="(item, index) in filterForm" :key="index" :label="item.label" :prop="item.prop">
                  <el-select clearable class="newswlwr" v-if="item.type=='select'" v-model="form[item.prop]"  placeholder="请选择">
					<el-option
					v-for="(item,index) in item.child"
					:key="index"
					:label="item.name"
					:value="item.id">
					</el-option>
				</el-select>
                <el-cascader
                v-else-if="item.type=='cascader'"
            v-model="form[item.prop]"
            :options="item.option"
            :props="{
              expandTrigger: item.expandTrigger || 'hover',
              label: item.vlabel||'label',
              value: item.vvalue ||'value',
              children: item.children || 'children',
            }"
          ></el-cascader>
          <el-date-picker
            v-else-if="item.type=='date'"
              v-model="form[item.prop]"
              type="datetimerange"
              range-separator="至"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期"
              :default-time="['00:00:00', '23:59:59']"
              end-placeholder="结束日期">
            </el-date-picker>
                <el-input v-else v-model="form[item.prop]" autocomplete="off" :placeholder="item.pl" clearable></el-input>
                
                
                </el-form-item>
                
              </el-form>
              <div class="drawer-footer">
                <el-button @click="resetForm('form')">重 置</el-button>
                <el-button type="primary" @click="confirmFn">确 定</el-button>
              </div>
        </el-drawer>
    </div> 
</template> 
<script>
import comTable from '@/components/comTable.vue'
export default {
    components: {comTable},
    props:{
        config:{
            type:Object,
            default:()=>{
                return {}
            }
        },
        filterForm:Array,
    },
    data() {
        return {
            drawer:false,
            form:{},
            selectedD:0,
        }
    },
    methods: {
        setDataFn(key,da){
            this.form[key]=da
        },
        selectedDatafn(da){
            this.selectedD = da.length;
            this.$emit('selectedDatafn',da)
        },
        getData(){
            this.$refs.table.getData(this.form)
        },
        drawerFn(){
            this.drawer = true;
        },
        confirmFn () {
			this.handleClose()
            /*参数出来将数组字符串*/
            let proms = {...this.form}
            this.filterForm.map(e=>{
                if(e.clfn){
                   e.clfn(proms)
                }
            })

            for(let key in proms){
                Array.isArray(proms[key]) && (proms[key] = proms[key].join(','))             
            }

            

			this.$refs.table.getData(proms)
		},
        resetForm() {
			this.$refs.form.resetFields()
        },
        handleClose(){
            this.drawer = false
        },
        showAll(){
            this.config.isSelection = !this.config.isSelection;
            this.config.showAllBtn = !this.config.showAllBtn;
        }
    },
};
</script>
<style lang='scss' scoped>
.feature {
	position: relative;
	height: 38px;
	margin-bottom: 10px;
	.feature-item {
		position: absolute;
		z-index: 9;
	}
	.filter {
        top: 10px;
		right: 10px;
		color: #999;
		cursor: pointer;
		img {
             margin-right: 3px;
		}
	}
}
.onBOx{
    height: calc(100% - 60px);
    .drawer-box {
        .el-form {
            width: 84%;
            margin: 0 auto;
        }
    }
    .drawer-footer {
        margin-top: 50px;
        text-align: center;
    }
    .el-table__body-wrapper {
      overflow-y: auto;
    }
}
.tabl_op{
    height: calc(100% - 38px);
}
</style>

<style lang='scss'>
.onBOx{
    .el-table__body-wrapper {
      overflow-y: auto;
    }
}
.all_btns{
    padding: 20px 0;
    position: relative;
    height: 40px;
    background: #fff;
    line-height: 40px;
}
.all_btns_1{
    position: absolute;
    top: 20px;
    left: 20px;
}
.all_btns_2{
    text-align: center;
}
.all_btns_2>span{
    cursor: pointer;
    display: inline-block;
    vertical-align: top;
    border: 1px solid #DCDFE6;
    border-radius: 5px;
    box-sizing: border-box;
    height: 30px;
    line-height: 28px;
    margin: 5px 10px;
    padding: 0 10px;
}
.all_btns_2>span:hover{
    color: #33B3FF;
}
.r-bgth{
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 69px;
    color: #999;
    cursor: pointer;
}
.r-bgth:hover{
    color: #33B3FF;
}
.r-bgth>img{
    display: inline-block;
    vertical-align: top;
    margin-top: 1px;
    margin-right: 2px; 
}
</style>